module.exports = "<div class=\"loader\" [ngClass]=\"{'hidden': show == false }\">\r\n    <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/loader/loader.component.html
// module id = ../../../../../src/app/shared/components/loader/loader.component.html
// module chunks = main